export default {
    isNewMessageAdded(stateMessagesLength, responseMessagesLength) {
      return stateMessagesLength != responseMessagesLength
    }
}
